import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss'],
  standalone: false,
})
export class SectionTitleComponent implements OnInit {
  @Input() hideUnderline: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
